import script from "./ValueSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./ValueSetup.vue?vue&type=script&setup=true&lang=js"

import "./ValueSetup.vue?vue&type=style&index=0&id=3ec86811&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ec86811"]])

export default __exports__